import React from 'react';

interface BiddingItemUploadStepCardProps {
  stepNumber: number;
  title: string;
  color: 'blue' | 'slate' | 'emerald'; // 使用する色を制限
  children: React.ReactNode;
}

export const BiddingItemUploadStepCard = ({ stepNumber, title, color, children }: BiddingItemUploadStepCardProps) => {
  // 色に応じたクラス名のマッピング
  const colorStyles = {
    blue: { border: 'border-blue-500', badge: 'bg-blue-50 text-blue-600 ring-blue-100' },
    slate: { border: 'border-slate-400', badge: 'bg-slate-100 text-slate-600 ring-slate-200' },
    emerald: { border: 'border-emerald-500', badge: 'bg-emerald-100 text-emerald-600 ring-emerald-200' },
  };

  const style = colorStyles[color];

  return (
    <div className={`bg-white rounded-2xl shadow-xl shadow-slate-200/50 border-t-4 ${style.border} overflow-hidden relative`}>
      <div className="pt-4 pb-6 flex flex-col items-center text-center">
        
        {/* ヘッダー部分 */}
        <div className="flex items-center justify-center gap-4 mb-4">
          <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl border-4 border-white shadow-sm ring-1 flex-shrink-0 ${style.badge}`}>
            {stepNumber}
          </div>
          <h2 className="text-xl font-bold text-slate-800">{title}</h2>
        </div>

        {/* コンテンツ部分 */}
        {children}
      </div>
    </div>
  );
};